import { z } from 'zod';

import { productKeySchema } from './query-params';

const outboundAuthConfigSchema: z.ZodObject<
	{
		url: z.ZodString;
		userNeedsOAuth: z.ZodBoolean;
	},
	'strip',
	z.ZodTypeAny,
	{
		url: string;
		userNeedsOAuth: boolean;
	},
	{
		url: string;
		userNeedsOAuth: boolean;
	}
> = z.object({
	url: z.string(),
	userNeedsOAuth: z.boolean(),
});
export type OutboundAuthConfig = z.infer<typeof outboundAuthConfigSchema>;

export const outboundAuthConfigsSchema: z.ZodUnion<
	[
		z.ZodRecord<
			z.ZodNativeEnum<{
				readonly Airtable: 'airtable';
				readonly Asana: 'asana';
				readonly Atlas: 'townsquare';
				readonly AtlassianWebCrawler: 'atlassian-web-crawler';
				readonly Bitbucket: 'bitbucket';
				readonly Compass: 'compass';
				readonly Confluence: 'confluence';
				readonly Dropbox: 'dropbox';
				readonly Figma: 'figma';
				readonly Github: 'github';
				readonly Gmail: 'gmail';
				readonly GoogleCalendar: 'google-calendar';
				readonly GoogleDrive: 'drive';
				readonly Jira: 'jira';
				readonly JiraProductDiscovery: 'jira-product-discovery';
				readonly JiraServiceManagement: 'jira-servicedesk';
				readonly Loom: 'loom';
				readonly Miro: 'miro';
				readonly Notion: 'notion';
				readonly OneDrive: 'onedrive';
				readonly Opsgenie: 'opsgenie';
				readonly OutlookCalendar: 'outlook-calendar';
				readonly Sharepoint: 'sharepoint';
				readonly Slack: 'slack';
				readonly Teams: 'teams';
				readonly Trello: 'trello';
				readonly Zendesk: 'zendesk';
			}>,
			z.ZodObject<
				{
					url: z.ZodString;
					userNeedsOAuth: z.ZodBoolean;
				},
				'strip',
				z.ZodTypeAny,
				{
					url: string;
					userNeedsOAuth: boolean;
				},
				{
					url: string;
					userNeedsOAuth: boolean;
				}
			>
		>,
		z.ZodRecord<z.ZodString, z.ZodNever>,
	]
> = z.record(productKeySchema, outboundAuthConfigSchema).or(z.record(z.never())); // Allow for empty objects = {}
export type OutboundAuthConfigsType = z.infer<typeof outboundAuthConfigsSchema>;
